import React from 'react';
import {
    Create,
    Datagrid,
    DateField,
    Edit,
    Filter,
    List,
    maxValue,
    minValue,
    number,
    ReferenceField,
    ReferenceInput,
    required,
    SelectInput,
    SimpleForm,
    TextField,
    TextInput,
} from 'react-admin';
import { DateInput } from 'react-admin-date-inputs';
import { withStyles } from '@material-ui/core/styles';
import {
    BulkDeleteButtonAdmin,
    CustomPagination,
    isGeEmployee,
    isPartner,
    isPartnerService,
    stylesWide,
    ToolbarSave,
    ToolbarSaveAllDeleteAdmin,
} from './utils';
import { PartnerContractSessionVisibilityInput } from './PartnerContracts/SessionVisibilityInput';

const PartnerContractsFilter = props => (
    <Filter {...props}>
        {isPartner(props.permissions) ? (
            <SelectInput
                label="Поле"
                source="field"
                choices={[
                    { id: 'id', name: 'Id договора' },
                    { id: 'partner_id', name: 'Id партнера' },
                    { id: 'number_accounting', name: 'Номер договора в 1С' },
                    { id: 'com_cond', name: 'Комиссия партнера' },
                    { id: 'issue_date', name: 'Дата заключения договора' },
                    { id: 'start_date', name: 'Дата начала действия договора' },
                    { id: 'status', name: 'Статус' },
                    { id: 'created', name: 'Время создания' },
                    { id: 'updated', name: 'Последнее обновление' },
                ]}
                alwaysOn
            />
        ) : (
            <SelectInput
                label="Поле"
                source="field"
                choices={[
                    { id: 'id', name: 'Id договора' },
                    { id: 'partner_id', name: 'Id партнера' },
                    { id: 'number_accounting', name: 'Номер договора в 1С' },
                    { id: 'com_cond', name: 'Комиссия партнера' },
                    { id: 'other_cond', name: 'Прочие условия' },
                    { id: 'issue_date', name: 'Дата заключения договора' },
                    { id: 'start_date', name: 'Дата начала действия договора' },
                    { id: 'end_date', name: 'Дата окончания действия договора' },
                    { id: 'details', name: 'Детали' },
                    { id: 'status', name: 'Статус' },
                    { id: 'created', name: 'Время создания' },
                    { id: 'updated', name: 'Последнее обновление' },
                ]}
                alwaysOn
            />
        )}
        <TextInput
            label="Поиск"
            source="q"
            alwaysOn
        />
    </Filter>
);

export const PartnerContractsList = ({ permissions, ...props }) => (
    <List
        {...props}
        filters={<PartnerContractsFilter permissions={permissions} />}
        bulkActionButtons={
            !isPartner(permissions) && !isPartnerService(permissions) ? (
                <BulkDeleteButtonAdmin permissions={permissions} />
            ) : (
                false
            )
        }
        pagination={<CustomPagination />}
    >
        <Datagrid rowClick="edit">
            <TextField
                label="Id договора"
                source="id"
            />
            <ReferenceField
                label="Партнер"
                source="partner_id"
                reference="partners"
                linkType={false}
                validate={required()}
                allowEmpty
            >
                <TextField source="name" />
            </ReferenceField>
            {/* {isEmployee(permissions) &&
        <ReferenceField label="Франчайзи" source="franchisee_id" reference="franchisee" linkType={false} allowEmpty>
          <TextField source="name"/>
        </ReferenceField>
      } */}
            {!isPartner(permissions) && !isPartnerService(permissions) && (
                <TextField
                    label="Договор c франчайзи"
                    source="ff_contract_id"
                    validate={required()}
                />
            )}
            <TextField
                label="Номер договора в 1С"
                source="number_accounting"
            />
            <TextField
                label="Комиссия партнера"
                source="com_cond"
            />
            {!isPartner(permissions) && (
                <TextField
                    label="Прочие условия"
                    source="other_cond"
                />
            )}
            <DateField
                label="Дата заключения договора"
                source="issue_date"
                locales="ru-RU"
            />
            <DateField
                label="Дата начала действия договора"
                source="start_date"
                locales="ru-RU"
            />
            {!isPartner(permissions) && (
                <DateField
                    label="Дата окончания действия договора"
                    source="end_date"
                    locales="ru-RU"
                />
            )}
            {!isPartner(permissions) && (
                <TextField
                    label="Детали"
                    source="details"
                />
            )}
            <TextField
                label="Статус"
                source="status"
            />
            <DateField
                label="Время создания"
                source="created"
                showTime
                locales="ru-RU"
            />
            <DateField
                label="Последнее обновление"
                source="updated"
                showTime
                locales="ru-RU"
            />
        </Datagrid>
    </List>
);

export const AddPartnerContract = withStyles(stylesWide)(({ classes, permissions, ...props }) => (
    <Create
        classes={classes}
        {...props}
    >
        <SimpleForm classes={classes}>
            <ReferenceInput
                perPage={10000}
                label="Партнер"
                source="partner_id"
                reference="partners"
                className={classes.wide}
                validate={required()}
            >
                <SelectInput
                    optionText="name"
                    className={classes.wide}
                />
            </ReferenceInput>
            {isGeEmployee(permissions) && (
                <ReferenceInput
                    perPage={10000}
                    label="Владелец договора - сервисный партнер"
                    source="owner_partner_service_id"
                    reference="partner_services"
                    className={classes.wide}
                    allowEmpty
                >
                    <SelectInput
                        optionText={choice => `${choice.name} (${choice.id})`}
                        className={classes.wide}
                    />
                </ReferenceInput>
            )}
            {!isPartnerService(permissions) && (
                <ReferenceInput
                    perPage={10000}
                    label="Договор c франчайзи"
                    source="ff_contract_id"
                    reference="ff_contracts"
                    className={classes.wide}
                    validate={required()}
                    allowEmpty
                >
                    <SelectInput optionText="id" />
                </ReferenceInput>
            )}
            <TextInput
                label="Номер договора в 1С"
                source="number_accounting"
                className={classes.wide}
            />
            <TextInput
                label="Комиссия партнера"
                source="com_cond"
                className={classes.wide}
                validate={[required(), number(), minValue(0), maxValue(1)]}
            />
            <TextInput
                label="Прочие условия"
                source="other_cond"
                className={classes.wide}
            />
            <DateInput
                label="Дата заключения договора"
                source="issue_date"
                options={{ format: 'dd.MM.YYYY' }}
                className={classes.wide}
            />
            <DateInput
                label="Дата начала действия договора"
                source="start_date"
                options={{ format: 'dd.MM.YYYY' }}
                className={classes.wide}
            />
            <DateInput
                label="Дата окончания действия договора"
                source="end_date"
                options={{ format: 'dd.MM.YYYY' }}
                className={classes.wide}
            />
            <TextInput
                label="Детали"
                source="details"
                className={classes.wide}
            />
            <SelectInput
                label="Статус"
                source="status"
                choices={[
                    { id: 'active', name: 'active' },
                    { id: 'inactive', name: 'inactive' },
                ]}
                className={classes.wide}
            />
        </SimpleForm>
    </Create>
));

export const EditPartnerContract = withStyles(stylesWide)(({ classes, permissions, ...props }) => (
    <Edit
        classes={classes}
        {...props}
    >
        <SimpleForm
            classes={classes}
            toolbar={
                isPartnerService(permissions) ? (
                    <ToolbarSave />
                ) : (
                    <ToolbarSaveAllDeleteAdmin permissions={permissions} />
                )
            }
        >
            <TextInput
                disabled
                label="Id договора"
                source="id"
                className={classes.wide}
            />
            <ReferenceInput
                perPage={10000}
                label="Партнер"
                source="partner_id"
                reference="partners"
                className={classes.wide}
                validate={required()}
            >
                <SelectInput optionText="name" />
            </ReferenceInput>
            {isGeEmployee(permissions) && (
                <ReferenceInput
                    perPage={10000}
                    label="Владелец договора - сервисный партнер"
                    source="owner_partner_service_id"
                    reference="partner_services"
                    className={classes.wide}
                    allowEmpty
                >
                    <SelectInput
                        optionText={choice => `${choice.name} (${choice.id})`}
                        className={classes.wide}
                    />
                </ReferenceInput>
            )}
            {!isPartnerService(permissions) && (
                <ReferenceInput
                    perPage={10000}
                    label="Договор c франчайзи"
                    source="ff_contract_id"
                    reference="ff_contracts"
                    className={classes.wide}
                    validate={required()}
                    allowEmpty
                >
                    <SelectInput optionText="id" />
                </ReferenceInput>
            )}
            <TextInput
                label="Номер договора в 1С"
                source="number_accounting"
                className={classes.wide}
            />
            <TextInput
                label="Комиссия партнера"
                source="com_cond"
                className={classes.wide}
                validate={[required(), number(), minValue(0), maxValue(1)]}
            />
            <TextInput
                label="Прочие условия"
                source="other_cond"
                className={classes.wide}
            />
            <DateInput
                label="Дата заключения договора"
                source="issue_date"
                options={{ format: 'dd.MM.YYYY' }}
                className={classes.wide}
            />
            <DateInput
                label="Дата начала действия договора"
                source="start_date"
                options={{ format: 'dd.MM.YYYY' }}
                className={classes.wide}
            />
            <DateInput
                label="Дата окончания действия договора"
                source="end_date"
                options={{ format: 'dd.MM.YYYY' }}
                className={classes.wide}
            />
            <TextInput
                label="Детали"
                source="details"
                className={classes.wide}
            />
            <SelectInput
                label="Статус"
                source="status"
                choices={[
                    { id: 'active', name: 'active' },
                    { id: 'inactive', name: 'inactive' },
                ]}
                className={classes.wide}
            />
            {(isGeEmployee(permissions) || isPartnerService(permissions)) && (
                <PartnerContractSessionVisibilityInput
                    permissions={permissions}
                    classes={classes}
                />
            )}
            <TextInput
                disabled
                label="Время создания"
                source="created"
                className={classes.wide}
            />
            <TextInput
                disabled
                label="Последнее обновление"
                source="updated"
                className={classes.wide}
            />
        </SimpleForm>
    </Edit>
));
